// Components==============
import indexTheme from 'actions/theme/index';
import indexProject from 'actions/project/index';
import Layout from 'components/Layout/Layout';
import BuilderCard from 'components/UI/BuilderCard/BuilderCard';
import Button from 'components/UI/Button/Button';
import Container from 'components/UI/Container/Container';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import FormDropdown from 'components/UI/Form/FormDropdown';
import updateProject from 'actions/project/update';
import { useFormValues } from 'hooks/useFormValues';
import { useMediaQ } from 'hooks/useMediaQ';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import { useFilter } from 'hooks/useFilter';
import { useThemesWithProject } from 'hooks/useThemesWithProject';
import React, { useEffect, useState, useContext } from 'react';
import { optionsFilter, searchFilter } from 'utilities/filters';
import { useHistory, useParams } from 'react-router';
import FormContext from 'utilities/FormContext';
import Token from 'components/UI/Token/Token';
import './SelectTheme.module.scss';
import { GlobalScanContext } from 'utilities/GlobalContext/GlobalScan';

export default function SelectTheme() {
  const { themeId } = useParams() as { themeId?: string };
  const dispatch = useReduxAction();
  const translate = useTranslate();
  const history = useHistory();
  const query = useMediaQ('min', 1024);

  const loading = useRedux((state) => state.theme?.loading);

  const [selectedTheme, setSelectedTheme] = useState<string>('');
  const [themeSelected, setThemeSelected] = useState(false);

  // context met image info
  const value = useContext(GlobalScanContext);

  useEffect(() => {
    dispatch(indexTheme());
    dispatch(indexProject());
  }, []);

  // Filter logic
  const { filterValues, setFilterValues, initial } = useFilter('projects');

  const f1 = searchFilter(filterValues[0].value as string);
  const f2 = optionsFilter(filterValues[1].value as number[], 'categories');

  const themesWithProject = useThemesWithProject([f1, f2]);
  const themesWithEmptyProject = themesWithProject.filter(
    (theme) => theme?.project?.process?.length === 0
  );

  const [emptyThemesPresent, setEmptyThemesPresent] = useState(false);

  useEffect(() => {
    if (themesWithEmptyProject.length === 0) {
      setEmptyThemesPresent(false);
    } else {
      setEmptyThemesPresent(true);
    }
  }, [themesWithEmptyProject]);

  const {
    formValues,
    handleChange,
    errors,
    setErrors,
    setFormValues,
  } = useFormValues({
    themeId: '',
  });

  useEffect(() => {
    if (selectedTheme) {
      setErrors((prev: any) => ({ ...prev, themeId: '' }));
      setFormValues((prev) => ({
        ...prev,
        themeId: selectedTheme,
      }));
      setThemeSelected(true);
    }
  }, [selectedTheme]);

  function clearScanContext() {
    value.setImage(undefined);
    value.setThemeId(0);
    value.setProjectId(0);
    value.setImageTaken(false);
  }

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const theme = themesWithProject?.find((t) => t?.name === selectedTheme);
    const theme_id = theme?.id!;

    // console.log(value.image);
    console.log(theme_id);
    console.log(value.projectId);

    const projectId = theme?.allProjects?.length
      ? theme?.allProjects[0].id
      : null;

    if (theme?.project?.process?.length === 0) {
      console.log('koppel nieuw thema');
      value.setThemeId(theme_id);
      dispatch(
        updateProject({
          projectId: value.projectId,
          themeId: theme_id,
          newTheme: true,
        })
      )
        .then((project: ProjectProjectEntity) => {
          console.log(project);
          clearScanContext();
          value.setSaveIsEditable(true);
          history.push(`/werkplaats/project-details/${project.id}`);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log('project not empty');
      return setErrors((prev: any) => ({
        ...prev,
        themeId: [translate('project.errors.project-not-empty')],
      }));
    }
  }

  return (
    <Layout grey>
      <Container>
        <form styleName="outer-wrapper" onSubmit={handleSubmit}>
          <BuilderCard title="" loading={loading}>
            <FormContext
              onChange={handleChange}
              errors={errors}
              formValues={formValues}
              setFormValues={setFormValues}
            >
              <div styleName="wrapper">
                <div>
                  <h2>{translate('project.terms.theme')}</h2>
                  {emptyThemesPresent ? (
                    <p styleName="text">
                      {translate('project.inputs.theme-select')}
                    </p>
                  ) : (
                    <p styleName="text">
                      {translate('project.inputs.no-theme-select')}
                    </p>
                  )}
                  {emptyThemesPresent && (
                    <FormDropdown
                      name="themeId"
                      dropdown={
                        <Dropdown
                          selectedItem={selectedTheme}
                          setSelectedItem={setSelectedTheme}
                          initialOptions={themesWithEmptyProject?.map(
                            (theme) => theme?.name || ''
                          )}
                          initialText={translate('filters.theme-filter.select')}
                          color="grey"
                          notAllOptions
                        />
                      }
                    />
                  )}
                </div>
              </div>
            </FormContext>
          </BuilderCard>
          <div styleName="buttons">
            {emptyThemesPresent ? (
              <>
                <Button color="blue" to="/werkplaats/thema-bouwer">
                  {translate('project.actions.create-theme')}
                </Button>
                <Button color="blue" inactive={!themeSelected}>
                  {translate('project.actions.connect-process')}
                </Button>
              </>
            ) : (
              <Button color="blue" to="/werkplaats/thema-bouwer">
                {translate('project.actions.create-new-theme')}
              </Button>
            )}
          </div>
        </form>
      </Container>
    </Layout>
  );
}
